
import Header from "@/components/header/header.vue";
import CountDown from "@/components/count-down/count-down.vue";
import FlashGoodBox from "./flash-good-box.vue";
import { useRouter } from "vue-router";
import { useSeckillHooks } from "@/hooks/index";
import Scrolltop from "@/components/scrolltop/index.vue";
export default {
  components: {
    Header,
    FlashGoodBox,
    CountDown,
    Scrolltop,
  },
  setup() {
    const router = useRouter()
    const {
      seckillList,
      loading,
      finished,
      onLoad,
      timingClick,
      active,
      status_name,
      flash_sale_times_arr,
      havebegun,
    }: any = useSeckillHooks();

    console.log('seckillList',seckillList);
    
    return {
      seckillList,
      loading,
      finished,
      onLoad,
      timingClick,
      active,
      status_name,
      flash_sale_times_arr,
      havebegun,
      router
    };
  },
};
